var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _ellipse, _path19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFongoLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 210,
    height: 65,
    viewBox: "0 0 210 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1,18.98c-.29,0-.59,0-.88.01h-.12s.02.12.02.12c.02.11,1.88,10.51,8.38,20.63.02-.03.04-.06.06-.09.02-.03.04-.06.06-.09,3.28-5.13,7.43-9.8,12.36-13.91v-.17s0-.12,0-.12v-.12c-6.11-4.15-12.8-6.26-19.89-6.26Z",
    fill: "#91c83f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25,40.45s-.04.07-.07.11c-.02.03-.04.07-.06.1-.02.03-.04.06-.05.09-4.2,6.76-6.88,14.35-7.98,22.58,2.59-1.01,10.78-4.49,19.05-11.05.03-.02.05-.04.08-.06.03-.02.06-.05.09-.07.01-.01.03-.02.04-.03l.14-.11.27-13.84.12-11.07c-4.63,3.96-8.53,8.45-11.62,13.35Z",
    fill: "#91c83f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3,2.17c2.31,2.86,9.11,12.23,7.54,21.54l.2.05s.9-2.96.31-7.19c-.52-3.72-2.31-9.19-7.81-14.61",
    fill: "#2eace3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.93,5.42c-.3.03-.57.16-.74.37-.14.17-.2.37-.18.57-5.62,2.14-7.97,6.4-8.95,9.74-1.15,3.93-.69,7.45-.69,7.49h.2c.34-10.75,6.64-15.33,9.56-16.89.17.26.49.43.86.43.04,0,.07,0,.11,0,.3-.03.57-.16.75-.37.14-.17.2-.37.18-.57-.05-.47-.53-.81-1.1-.76Z",
    fill: "#2eace3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.43,60.49c-.73-8.44-3.31-15.91-7.66-22.23-.02.03-.04.06-.06.09-.02.03-.04.06-.06.09-3.73,5.55-8.07,10.3-12.91,14.15-.02.02-.05.04-.07.06h0s-.03.11-.03.11c10.31,6.1,20.58,7.82,20.68,7.84l.13.02v-.13Z",
    fill: "#2eace3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.27,51.73c.06-.04.11-.08.17-.13-.02-.01-.04-.02-.06-.04l-.11.16Z",
    fill: "#b3d7f2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.28,51.5l-.08.12v.17s.05-.04.08-.06l.11-.16s-.07-.04-.11-.07Z",
    fill: "#b2d7f2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2,51.45v.17s.08-.12.08-.12c-.03-.02-.05-.03-.08-.05Z",
    fill: "#b1d6f2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1,25.48s-.08.06-.12.09v.19s0,.23,0,.23c.04.02.07.05.11.07v-.59Z",
    fill: "#2eace3"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M22.08,26.3s-.07-.05-.11-.07l-.13,12.28.24-12.2Z",
    fill: "#2eace3"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M22.09,26.17v-.11s-.07-.05-.11-.07v.11s.07.05.11.07Z",
    fill: "#2eace3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1,25.48v.59s-.01.11-.01.11v.13s-.24,12.2-.24,12.2l-.13,12.7c4.57-3.74,8.68-8.32,12.22-13.64.02-.02.03-.05.05-.07.02-.03.04-.06.06-.09.02-.03.04-.06.05-.08,6.28-9.52,8.99-18.73,9.69-21.41-7.91,1.24-15.19,4.47-21.68,9.58Z",
    fill: "#2eace3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.08,26.3v-.13s-.07-.05-.11-.07v.13s.07.05.11.07Z",
    fill: "#2eace3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M171.74,23.35h-1.15v-.38h2.75v.38h-1.14v3.05h-.46v-3.05Z",
    fill: "#929497"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M173.73,22.96h.63l1.08,2.89,1.09-2.89h.62v3.44h-.43v-2.86h-.01l-1.07,2.86h-.39l-1.07-2.86h0v2.86h-.43v-3.44Z",
    fill: "#929497"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M58.65,24.55c1.07-4.39.3-6.06.3-6.06-1.19-2.61-5.81-5.29-6.11,3.15-.12,2.55.41,6.12,1.13,9.8l7.83-1.6,1.48,5.64-8.07,1.72s1.54,6.36,3.26,11.82l-6.47,2.85c-1.72-6.12-3.2-13.37-3.2-13.37l-5.81,1.25-.77-5.88,5.52-1.13c-1.19-6.77-1.66-13.31-.12-15.74,3.74-5.82,9.61-6.89,14.72-3.21,0,0,5.04,3.62,3.09,11.11l-6.76-.36Z",
    fill: "#2eace3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M77.91,49.52c-6.41-.3-14.3-4.16-14.3-10.4s6.23-12.59,13.29-13.72c7-1.07,16.91,2.79,17.33,13.13.36,10.28-11.33,11.23-16.32,10.99ZM81.94,32c-5.22-.12-14.36.89-14.48,5.52-.06,4.57,7.18,5.76,11.99,5.88,4.87.12,11.27-2.73,11.33-5.82.06-3.09-3.56-5.47-8.84-5.59Z",
    fill: "#2eace3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M120.45,51.65l-14.24.36.06-3.86,5.1-1.13.95-12.06c.77-9.68-4.81-9.62-4.81-9.62,0,0-4.93.18-4.21,8.67l-.24,7.9,3.92,1.01-.06,3.27-14.36.24v-3.86l5.46-.77-.77-16.28-6.59-1.36-.18-3.27,10.8-1.66.12,2.5c3.74-2.26,9.43-2.97,13.41-.18,6.35,4.51,2.31,21.56,1.54,25.78l.18.06,3.92,1.01v3.27Z",
    fill: "#2eace3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M139.97,55.75l.42-8.92c-1.48,6.06-7.48,6.06-7.48,6.06-6.05,0-12.34-6.71-13.35-14.2-1.07-7.48,2.67-18.18,12.7-18.59,0,0,10.03-.42,10.44,11.52l-6.88.42c-.42-6.48-3.32-6.48-3.32-6.48-2.97,0-6.47,3.74-6.47,8.55s1.66,14.14,5.99,14.14c0,0,4.39,0,6.71-5.41h-7.54v-6.24l14,1.84,1.25,17.29h-6.47Z",
    fill: "#91c83f",
    stroke: "#8fc63f",
    strokeWidth: 0.17
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M160.83,50.52c-6.41-.3-14.3-4.16-14.3-10.4s6.23-12.59,13.29-13.72c7-1.07,16.91,2.79,17.33,13.13.36,10.28-11.33,11.23-16.32,10.99ZM164.86,33c-5.22-.12-14.36.89-14.48,5.52-.06,4.57,7.18,5.76,11.99,5.88,4.87.12,11.28-2.73,11.33-5.82.06-3.09-3.56-5.46-8.84-5.58Z",
    fill: "#91c83f",
    stroke: "#8fc63f",
    strokeWidth: 0.17
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.76,
    cy: 1.3,
    rx: 0.72,
    ry: 1.14,
    transform: "translate(2.81 9.39) rotate(-44.93)",
    fill: "#27abe2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M196.56,26.27l.22-6.16s0-.05-.02-.06l-.04-.04s-.11-.08-.18-.08c-.01,0-.03,0-.04,0l-5.89,1.04.78-2.35c.08-.24,0-.5-.22-.65l-6.26-4.38,1.85-.84s.07-.07.05-.11l-1.35-4.56,4.15.98s.02,0,.02,0c.04,0,.09-.03.1-.09l.25-2.09,2.97,2.86s.08.05.13.05c.06,0,.12-.03.15-.07.03-.04.05-.09.04-.15l-1.03-6.11,2.36,1.1c.06.03.13.05.2.05.18,0,.34-.1.43-.26l2.11-4.2,2.11,4.2c.08.16.24.26.43.26.07,0,.14-.02.2-.05l2.36-1.1-1.03,6.11c0,.06,0,.11.04.15.04.04.1.07.15.07.05,0,.09-.02.13-.05l2.97-2.86.25,2.09c0,.06.06.09.1.09,0,0,.02,0,.02,0l4.15-.98-1.35,4.56s0,.09.05.11l1.85.84-6.26,4.38c-.21.15-.3.41-.22.65l.78,2.35-5.89-1.04s-.03,0-.04,0c-.07,0-.13.03-.18.08l-.04.04s-.02.04-.02.06l.22,6.16h-1.53",
    fill: "#ef4545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFongoLogo);
export default __webpack_public_path__ + "static/media/fongo-logo.4bb812e2e092899ed83506dd5274116d.svg";
export { ForwardRef as ReactComponent };